var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312-144q-30 0-51-21t-21-51v-480h-12q-15 0-25.5-10.5T192-732q0-15 10.5-25.5T228-768h156v-12q0-15 10.5-25.5T420-816h120q15 0 25.5 10.5T576-780v12h156q15 0 25.5 10.5T768-732q0 15-10.5 25.5T732-696h-12v480q0 30-21 51t-51 21H312Zm168-261 55 55q11 11 25.5 10.5T586-351q11-11 11-25.5T586-402l-55-54 55-55q11-11 11-25.5T586-562q-11-11-25.5-11T535-562l-55 55-55-55q-11-11-25-11t-25 11q-11 11-11 25.5t11 25.5l54 55-55 55q-11 11-10.5 25t11.5 25q11 11 25.5 11t25.5-11l54-54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.15740e67a79a63b46a94103693c38f04.svg";
export { ForwardRef as ReactComponent };